// VINERI — interacciones globales
document.addEventListener('DOMContentLoaded', function () {
  initRevelado();
});

function initRevelado() {
  var elementos = document.querySelectorAll('.vr-reveal');
  if (!elementos.length) return;

  if (!('IntersectionObserver' in window)) {
    elementos.forEach(function (el) { el.classList.add('vr-visible'); });
    return;
  }

  var observador = new IntersectionObserver(
    function (entradas) {
      entradas.forEach(function (entrada) {
        if (entrada.isIntersecting) {
          entrada.target.classList.add('vr-visible');
          observador.unobserve(entrada.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );

  elementos.forEach(function (el) { observador.observe(el); });
}
